import classNames from 'classnames';

import { UnspecifiedAbsence } from '../types';
import { Interval } from 'components/types';

import Absence from './Absence';

type Props = {
  absence: UnspecifiedAbsence;
  interval: Interval;
};

export default function Unspecified({ absence, interval }: Props) {
  return (
    <Absence
      absence={absence}
      className={classNames('absence', 'unspecified')}
      borderColor="#dedede"
      interval={interval}
      background="white"
    />
  );
}
